import { BannerSection } from '@sketch/components'
import styled from 'styled-components'

export const Banner = styled(BannerSection)`
  min-height: 40px;
  flex: 1 1 100%;
`
